import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PwaService {

  INSTALL_PROMPT_EVENT: any = null;

  constructor() { }

  // Getting current platform
  getDeviceOS(): 'iOS' | 'Android' | 'Other' {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (/android/i.test(userAgent)) {
      return 'Android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return 'iOS';
    }
    return 'Other';
  }
  // Getting current platform

  //Checking Android or Windows PWA Instance
  checkAndroidOrWindowsPWAInstance(): boolean {
    const IS_PWA_INSTALLED: boolean = window.matchMedia('(display-mode: standalone)').matches;
    return IS_PWA_INSTALLED;
  }
  //Checking Android or Windows PWA Instance

  // Checking iOS PWA Instance
  checkiOSPWAInstance(): boolean {
    const IS_IOS_PWA: boolean = (window as any).navigator.standalone === true;
    return IS_IOS_PWA;
  }
  // Checking iOS PWA Instance

  // Checking PWA installation viability
  public async checkPWAInstallCapacity(): Promise<boolean> {
    return new Promise((resolve) => {
      let resolved: boolean = false;
      const EVENT_LISTENER = (event: any): void => {
        event.preventDefault();
        this.INSTALL_PROMPT_EVENT = event;
        resolved = true;
        resolve(true);
      }
      window.addEventListener('beforeinstallprompt', EVENT_LISTENER, { once: true });
      setTimeout(() => {
        if(!resolved) {
          resolve(false);
        }
      }, 3500);
    });
  }

  // Checking PWA installation viability

  // Asking to install PWA
  async askToInstallPWA(): Promise<'installed'|'dismissed'|'timeout'|'no-prompt'> {
    let result: any;
    if (this.INSTALL_PROMPT_EVENT !== null && this.INSTALL_PROMPT_EVENT !== undefined) {
      this.INSTALL_PROMPT_EVENT.prompt();
      // 1) Preparar escucha del evento "appinstalled" (la única confirmación real)
      const installedPromise = new Promise<'installed'>(resolve => {
        const onInstalled = () => {
          window.removeEventListener('appinstalled', onInstalled as any);
          resolve('installed');
        };
        window.addEventListener('appinstalled', onInstalled as any, { once: true });
      });

       // 2) Preparar timeout por si el usuario se va por otra ruta
      const timeoutPromise = new Promise<'timeout'>(resolve => {
        const id = setTimeout(() => resolve('timeout'), 5000);
        // (opcional) guarda id para cancelarlo si quieres
      });
      // 3) Mostrar el prompt e inspeccionar la decisión del usuario
      this.INSTALL_PROMPT_EVENT.prompt();
      const choice = await this.INSTALL_PROMPT_EVENT.userChoice.catch(() => null);
      if (!choice) {
        // Error/edge; esperamos por si de todos modos se instala y dispara "appinstalled"
        const result = await Promise.race([installedPromise, timeoutPromise]);
        return result;
      }
      if (choice.outcome === 'dismissed') {
        return 'dismissed';
      }

      // 4) El usuario aceptó: ahora esperamos la confirmación real de instalación
      //    (puede tardar unos segundos; si no llega, resolvemos por timeout)
      result = await Promise.race([installedPromise, timeoutPromise]);
    }
    return result;
  }
  // Asking to install PWA


  async isLikelyInstalled() {
    if (localStorage.getItem('pwa_installed') === '1') return true; 
    const rel = (navigator as any).getInstalledRelatedApps();
    if (rel) {
      try {
        const apps = await rel();
        return apps?.some((a: any) => a.platform === 'webapp');
      } catch {}
    }
    return false;
  }

}
